module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Val_Mara_TI_COA-f893141631a29de943066a82c122be5c.svg";